import { InformationMemorandumDetail } from '@containers/information-memorandum/models/information-memorandum-detail';
import { InformationMemorandumService } from '@core/services/information-memorandum.service';
import { ProfileService } from '@core/services/profile.service';
import { Profile } from '@model/profile';
import { AxiosResponse } from 'axios';
import { catchError, firstValueFrom, forkJoin, throwError } from 'rxjs';

export interface InformationMemorandumDefaultData {
  profile: Profile;
  imDetail: InformationMemorandumDetail;
}

export default async function getInformationMemorandumDefaultData(
  imId: number | string
): Promise<Partial<InformationMemorandumDefaultData>> {
  const data$ = forkJoin({
    profile: ProfileService.getProfile(),
    imDetail: InformationMemorandumService.getImDetail(imId),
    imMenu: InformationMemorandumService.getImMenu(imId),
  }).pipe(
    catchError((e: AxiosResponse) => {
      if (e.status === 404) {
        window.location.href = '/';
      }
      return throwError(() => e);
    })
  );
  return await firstValueFrom(data$);
}
